import { useEffect, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';

import { QueryProvider } from '@/core/query';
import { createAppRouter } from '@/core/router';
import { xPlatform, xRoutes } from '@/modules/engagement';
import { useAuthStore } from '@/stores/auth';
import { useNavigationStore } from '@/stores/navigation';

import type { Platform } from '@/types/navigation';
import type { RouteObject } from 'react-router-dom';

const platforms: Platform[] = [xPlatform];
const routes: RouteObject[] = [...xRoutes];

function App(): React.JSX.Element {
  const initialize = useAuthStore((s) => s.initialize);
  const registerPlatform = useNavigationStore((s) => s.registerPlatform);

  useEffect(() => {
    initialize();
    platforms.forEach(registerPlatform);
  }, [initialize, registerPlatform]);

  const router = useMemo(() => createAppRouter(routes), []);

  return (
    <QueryProvider>
      <RouterProvider router={router} />
    </QueryProvider>
  );
}

export default App;
